/* eslint-disable react/no-array-index-key */
/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThreeDots } from 'react-loader-spinner';
import {
  NOT_AVAILABLE,
  HOTEL_NAME,
  HOTEL_SERACH,
} from '../../../Utils/Constants/GlobalConstants';
import './css/HotelsFilter.css';
import {
  searchHotelsInCountry,
  getHotelsByCountryId,
} from '../../../Utils/ElasticUtils';
import { TOUR_SEARCH_HOTELS_INDEX } from '../../../Utils/Constants/Indexes';
import {
  changeHotelsFilter,
  changeSelectedHotels,
} from '../../../DataStore/actions/FiltersAction';
import { HOTELS_PARAM } from '../../../Utils/Constants/urlParams';
import { getInitialSearchUrlObj } from '../../../Utils/CommonUtils';
import { ReactComponent as Clear } from '../../../images/clear-cross-r.svg';

const mapStateToProps = (state) => ({ ...state });

class HotelsFilter extends React.Component {
  constructor() {
    super();

    this.state = {
      value: '',
      isSpinnerVisible: false,
      isError: false,
      hotels: [],
      hotelsVisible: false,
      initialSearh: [],
    };
  }

  removeHotelFilter = (id) => {
    const {
      hotelsFilter,
      changeHotelsFilter: changeHotelsFilterAction,
      changeSelectedHotels: changeSelectedHotelsAction,
      updateHotels,
    } = this.props;

    const newHotelsFilterState = hotelsFilter.filter(
      (hotel) => hotel.id !== id,
    );

    changeHotelsFilterAction(newHotelsFilterState);
    changeSelectedHotelsAction(newHotelsFilterState);

    this.renderHotelFilterUrl(newHotelsFilterState);

    updateHotels(newHotelsFilterState);
  };

  renderHotelFilterUrl = (newState) => {
    const { navigate, location, countryLanding } = this.props;
    let queryParameters;

    if (countryLanding) {
      queryParameters = getInitialSearchUrlObj(this.props);
      if (newState.length > 0) {
        queryParameters.append(
          HOTELS_PARAM,
          newState.map((e) => e.id),
        );
      }
    } else {
      queryParameters = new URLSearchParams(location.search);
      queryParameters.delete(HOTELS_PARAM);

      if (newState.length > 0) {
        queryParameters.append(
          HOTELS_PARAM,
          newState.map((e) => e.id),
        );
      }
    }

    navigate({
      pathname: '/search',
      search: queryParameters.toString(),
    });
  };

  renderSelectedHotels = (hotels) =>
    hotels.map((hotel, index) => {
      const { isDisabled } = this.props;
      return (
        <div
          className="selected_hotel hotel_text"
          key={`selectdHotels-${index}`}
        >
          <div>{`${hotel.name} ${this.getStars(hotel.stars)}`}</div>
          {!isDisabled && (
            <button
              onClick={() => this.removeHotelFilter(hotel.id)}
              type="button"
              className="selected_hotel_clear"
            >
              <Clear />
            </button>
          )}
        </div>
      );
    });

  onChange = (event) => {
    const { destination } = this.props;
    const { value } = event.target;
    this.setState({ value });

    searchHotelsInCountry(value, TOUR_SEARCH_HOTELS_INDEX, destination.id).then(
      (resoponse) => {
        const { hits } = resoponse.data;

        if (hits) {
          const hotelsResult = hits.hits.map((item) => item._source);

          this.setState({
            hotels: hotelsResult,
          });
        }
      },
    );
  };

  onFocus = () => {
    const { hotels } = this.state;
    const { destination } = this.props;

    if (hotels.length === 0) {
      this.setState({ isSpinnerVisible: true });

      getHotelsByCountryId(destination.id, TOUR_SEARCH_HOTELS_INDEX).then(
        (resoponse) => {
          const { hits } = resoponse.data;
          const hotelsResult = hits.hits.map((item) => item._source);

          this.setState({
            isSpinnerVisible: false,
            hotelsVisible: true,
            hotels: hotelsResult,
            initialSearh: hotelsResult,
          });
        },
      );
    } else {
      this.setState({ hotelsVisible: true });
    }
  };

  async timeout(delay) {
    return new Promise((res) => {
      setTimeout(res, delay);
    });
  }

  onBlur = () => {
    this.waitAndClose();
  };

  async waitAndClose() {
    const { initialSearh } = this.state;
    await this.timeout(100);

    this.setState({
      value: '',
      hotelsVisible: false,
      hotels: initialSearh,
    });
  }

  addHotelFilter = (hotel) => {
    const {
      changeHotelsFilter: changeHotelsFilterAction,
      changeSelectedHotels: changeSelectedHotelsAction,
      hotelsFilter,
      updateHotels,
      countryLanding,
    } = this.props;

    if (hotelsFilter.filter((e) => e.id === hotel.id).length === 0) {
      const updatedHotel = hotel;
      updatedHotel.checked = true;

      const newState = hotelsFilter.concat(updatedHotel);

      if (countryLanding) {
        this.renderHotelFilterUrl(newState);
      } else {
        changeHotelsFilterAction(newState);
        changeSelectedHotelsAction(newState);

        this.renderHotelFilterUrl(newState);
        updateHotels(newState);
      }
    }
  };

  getStars = (stars) => {
    let result = '';
    if (stars > 0) {
      result = `${stars}*`;
    }

    return result;
  };

  renderHotelSuggestions = (hotels) =>
    hotels.map((hotel, index) => (
      <button
        key={`hotelOption-${index}`}
        type="button"
        onClick={() => this.addHotelFilter(hotel)}
        className="hotel_suggestion_item"
      >
        {`${hotel.name} ${this.getStars(hotel.stars)}`}
      </button>
    ));

  render() {
    const { selectedHotels } = this.props;
    const { value, isSpinnerVisible, isError, hotelsVisible, hotels } =
      this.state;

    return (
      <div className="filter_item">
        <div className="bm_text_16 mb_10">{HOTEL_SERACH}</div>

        <input
          className="auto_suggest_input"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.onChange}
          value={value}
          placeholder={HOTEL_NAME}
          disabled={false}
        />

        <ThreeDots
          visible={isSpinnerVisible}
          height="30"
          width="30"
          color="#00BFFF"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperClass="hotel_filter_spinner"
        />

        {isError && <div className="hotel_text">{NOT_AVAILABLE}</div>}

        {hotelsVisible && (
          <div className="hotel_suggestion_wrapp_p">
            <div className="hotel_suggestion_wrapp">
              {this.renderHotelSuggestions(hotels)}
            </div>
          </div>
        )}
        {this.renderSelectedHotels(selectedHotels)}
      </div>
    );
  }
}

HotelsFilter.propTypes = {
  destination: PropTypes.instanceOf(Object).isRequired,
  hotelsFilter: PropTypes.instanceOf(Array).isRequired,
  selectedHotels: PropTypes.instanceOf(Array).isRequired,
  changeHotelsFilter: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  isDisabled: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  updateHotels: PropTypes.func.isRequired,
  changeSelectedHotels: PropTypes.func.isRequired,
  countryLanding: PropTypes.instanceOf(Object),
};

HotelsFilter.defaultProps = {
  isDisabled: false,
  countryLanding: null,
};

export default connect(mapStateToProps, {
  changeHotelsFilter,
  changeSelectedHotels,
})(HotelsFilter);
